<template lang="pug">
  div#app.overflow-hidden
    div(v-if="shared.blocked && UserData.loginStatus" role="status" style="position:fixed;inset:0;z-index:99999;background:#fff;display:flex;align-items:center;justify-content:center;padding:24px;text-align:center") {{ shared.message }}
    template(v-if="isLoaded && !shared.blocked")
      Layout(v-if="!error")
      Error(v-else)
      Dialog(v-if="!error")
</template>

<script>
import { plusBrowseCount, getActivities } from './api'
import Layout from './views/Layout.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import Error from './views/Error.vue'
import { Toast } from '@/utils/helper'
import { sessionState, recordSharedActivity, startSessionMonitor, consumeReturn } from '@/utils/shared-session'

const IDLE_TIMEOUT = 15 * 60 * 1000
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'touchmove', 'wheel', 'scroll']

export default {
  name: 'App',
  data () {
    return {
      shared: sessionState,
      lastActivityAt: Date.now(),
      idleInterval: null,
      maintenanceInterval: null,
      maintenanceChecking: false,
      maintenanceRecoveryShown: false,
      isLoaded: false // 加一個 isLoaded flag
    }
  },
  methods: {
    ...mapMutations(['toggleMenuBar']),
    ...mapActions(['getListModel', 'getMemberModel']),
    handleDialog (event) {
      console.log('layout')
      console.log(event)
    },
    clearTimer () {
      clearInterval(this.idleInterval)
      this.idleInterval = null
    },
    setTimer () {
      this.lastActivityAt = Date.now()
      if (this.idleInterval === null) {
        this.idleInterval = window.setInterval(this.cookieTimeout, 1000)
      }
    },
    recordActivity (event) {
      if (!event.isTrusted) return
      if (sessionState.mode === 'shared') { recordSharedActivity(event); return }
      // 先檢查期限，避免背景分頁恢復後的第一個操作延長已逾時的登入。
      this.cookieTimeout()
      this.lastActivityAt = Date.now()
    },
    cookieTimeout () {
      if (sessionState.mode !== 'legacy' || !this.UserData.loginStatus) {
        return
      }
      if (Date.now() - this.lastActivityAt >= IDLE_TIMEOUT) {
        this.logout()
        Toast.fire({
          icon: 'warning',
          title: '閒置逾時15分鐘\n請重新登入',
          customClass: { popup: 'idle-timeout-dialog' },
          showConfirmButton: false,
          showCloseButton: true,
          closeButtonAriaLabel: '關閉'
        })
      }
    },
    logout () {
      this.toggleMenuBar(false)
      this.$store.commit('logout')
      if (this.$route.path !== '/home') {
        this.$router.replace('/home')
      }
    },
    async checkMaintenance () {
      if (
        this.$route.path !== '/error' ||
        sessionStorage.getItem('maintenanceDetected') !== 'true' ||
        this.maintenanceChecking ||
        this.maintenanceInterval ||
        this.maintenanceRecoveryShown
      ) {
        return
      }

      this.maintenanceChecking = true
      try {
        const systemImages = await this.getListModel({ name: 'SystemImages' })

        if (systemImages.data) {
          // console.log('棒棒')
        }
      } catch (error) {
        // 維護中，持續檢查
        console.log('維護中，開始檢查')

        this.maintenanceInterval = setInterval(async () => {
          try {
            const check = await this.getListModel({ name: 'SystemImages' })

            console.log('檢查結果:', check)
            if (check.data && check.data.length > 0 && check.data[3]) {
              clearInterval(this.maintenanceInterval)
              this.maintenanceInterval = null

              if (this.maintenanceRecoveryShown) {
                return
              }
              this.maintenanceRecoveryShown = true
              Toast.fire({
                icon: 'warning',
                title: '維護已結束\n請點選確認重新進入首頁',
                confirmButtonText: '確認',
                allowOutsideClick: false,
                allowEscapeKey: false
              }).then((result) => {
                if (result.isConfirmed) {
                  sessionStorage.removeItem('maintenanceDetected')
                  sessionStorage.removeItem('hasRedirected')
                  window.location.href = '/'
                }
              })
            }
          } catch (error) {
            // 維護期間 API 尚未恢復，等待下一次檢查。
          }
        }, 10000)
      } finally {
        this.maintenanceChecking = false
      }
    }
  },
  mounted () {
    startSessionMonitor(() => {
      this.$store.commit('logout')
      if (this.$route.path !== '/home' && this.$route.path !== '/sso/return') this.$router.replace('/home')
    })
    ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, this.recordActivity, { capture: true, passive: true })
    })
    document.addEventListener('visibilitychange', this.cookieTimeout)
    window.addEventListener('focus', this.cookieTimeout)
    window.addEventListener('pageshow', this.cookieTimeout)
    this.setTimer()
    document.oncontextmenu = () => {
      window.event.returnValue = false
      return false
    }
  },
  beforeDestroy () {
    this.clearTimer()
    ACTIVITY_EVENTS.forEach(event => {
      document.removeEventListener(event, this.recordActivity, true)
    })
    document.removeEventListener('visibilitychange', this.cookieTimeout)
    window.removeEventListener('focus', this.cookieTimeout)
    window.removeEventListener('pageshow', this.cookieTimeout)
    if (this.maintenanceInterval) {
      clearInterval(this.maintenanceInterval)
    }
  },
  async created () {
    if (await consumeReturn()) return
    try {
      this.$store.commit('initModel')
      if (this.UserData.loginStatus) {
        this.UserData.login()
        this.getMemberModel()
        if (this.global.loginPage) {
          this.$router.replace(this.global.loginPage)
        }
      }
      getActivities()
      this.getListModel({ name: 'SystemRights' })
      const systemImages = this.getListModel({ name: 'SystemImages' })
      document.querySelectorAll('link').forEach(dom => {
        if (dom.rel === 'icon' && systemImages.data && systemImages.data[3]) {
          dom.href = systemImages.data[3].image
        }
      })
      const seometas = this.getListModel({ name: 'Seometas' })
      if (seometas.data && seometas.data[0]) {
        document.querySelector('title').innerHTML = seometas.data[0].title
      } else {
        document.querySelector('title').innerHTML = '東震股份有限公司'
      }
      const categories = this.getListModel({ name: 'Categories' })
      categories.data[0].set({
        name: '全部商品'
      })
      plusBrowseCount()
    } catch (error) {
      // console.error('初始化失敗', error)
    } finally {
      this.isLoaded = true // 無論成功或失敗，最後設 isLoaded=true
    }
  },
  watch: {
    'UserData.loginStatus' () {
      this.lastActivityAt = Date.now()
    }
  },
  computed: {
    ...mapState({
      global: state => state.global,
      Categories: state => state.model.Categories,
      UserData: state => state.model.UserData
    }),
    error () {
      const isMaintenancePage = this.$route.path === '/error'
      if (isMaintenancePage) {
        this.checkMaintenance()
      }
      return isMaintenancePage
    }
  },
  components: {
    Layout,
    Error
  }
}
</script>

<style lang="scss" src="./scss/main.scss"></style>
